<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/cart_sub.jpg" />
      <h1 class="">ご注文</h1>
    </div>
    <div class="tt dairi_no" id="PROXY">
      <!-- 動的HTML生成部 代理注文入力欄 -->
      <div v-show="isCanProxy">
        <dl class="list-detail">
          <dt :class="{ 'is-active': showProxy }" v-on:click="togleShowProxy">
            代理注文をする
          </dt>
          <dd v-show="showProxy" class="proxy_order">
            <div class="mr-2">傘下会員番号</div>
            <input
              type="text"
              style="ime-mode: disabled"
              maxlength="10"
              v-model="memberNo"
            />
            <div class="rank_btn">
              <input
                type="button"
                value="設定"
                v-on:click="setMemberNo"
                class="btn ml-3"
              />
              <input
                type="button"
                value="クリア"
                v-on:click="clearMemberNo"
                class="btn ml-2"
              />
            </div>
          </dd>
        </dl>
      </div>
    </div>

    <div class="lineup_title">
      <h2>商品</h2>
    </div>

    <template v-for="categoryItem in products" :key="categoryItem.category">
      <div class="lineup_sub_title">
        <h3>{{ categoryItem.category }}</h3>
      </div>
      <div class="list-shouhin">
        <ul>
          <ProductItem
            v-for="product in categoryItem.items"
            :key="product.code"
            :no="product.no"
            :title="product.title"
            :limit="product.limit"
            :type="product.type"
            :code="product.code"
            :price="product.price"
            :point="product.point"
            :isProxy="isProxy"
            @add="cartRefresh"
          />
        </ul>
      </div>
    </template>

    <div class="lineup_title mt-50">
      <h2>ツール品</h2>
    </div>
    <div class="list-shouhin">
      <ul>
        <ProductItem
          v-for="product in tools"
          :key="product.code"
          :no="product.no"
          :title="product.title"
          :limit="product.limit"
          :type="product.type"
          :code="product.code"
          :price="product.price"
          :point="product.point"
          :isProxy="isProxy"
          @add="cartRefresh"
        />
      </ul>
    </div>

    <section class="sec-cmn-02 text-center">
      <router-link class="btn" to="/shoppingguide"
        >ショッピングガイド</router-link
      >
    </section>

    <Cart ref="cart" />
  </section>
</template>

<style scoped>
.list-detail dd:first-of-type {
  display: flex;
}
.lineup_title {
  padding: 5px 0;
}
.lineup_title:nth-child(n + 4) {
  border-top: 1px solid #eee;
}
.lineup_title h2 {
  margin: 0;
}
.lineup_sub_title {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 5px 0;
}
.lineup_sub_title h3 {
  font-size: 26px;
  margin: 0;
}
.dairi_no {
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
.rank_id {
  align-items: flex-start !important;
}
.box_product {
  width: 33%;
  border: 1px solid #eee;
}
.box_product div:first-child {
  padding: 0 20px;
}
.box_product .d-flex {
  align-items: center;
}
.box_product select {
  width: 75px;
}
.list-shouhin {
  margin-bottom: 50px;
}
.list-shouhin > ul {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}
.list-shouhin > ul li {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.lineup_title.mt-50 {
  margin-top: 50px;
}
@media screen and (min-width: 700px) and (max-width: 991px) {
  .box_product {
    width: 50%;
  }
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .lineup_sub_title {
    border-bottom: none;
  }
  .rank_btn {
    margin-top: 1.5rem;
  }
  .box_product {
    width: 100%;
  }
  .list-detail dd.proxy_order {
    flex-direction: column;
  }
}
</style>

<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";

import ProductItem from "./components/ProductItem";
import Cart from "./components/Cart";

import Store from "@/modules/Store";

import Products from "@/modules/Products";
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();

let productStore = new Products();

let request = new Request();

let store = new Store();
export default {
  components: {
    ProductItem,
    Cart,
  },
  data() {
    return {
      memberNo: "",
      products: [],
      tools: [],
      isCanProxy: false,
      isProxy: false,
      showProxy: false,
      shoppingItem: [],
      shopping:true,
    };
  },
  mounted() {
    // 商品一覧を取得
    this.shopping = auth.getShopping();
    productStore.loadProducts();
    this.getProducts("", "");
    window.scroll(0, 0);
  },
  methods: {
    togleShowProxy() {
      console.log(this.showProxy);
      this.showProxy ? (this.showProxy = false) : (this.showProxy = true);
      console.log(this.showProxy);
    },
    cartRefresh() {
      this.$refs.cart.loadCart();
    },
    setMemberNo() {
      if (this.memberNo != "") {
        if (!this.memberNo.match(/[^0-9]*/)) {
          Message.error().fire({
            title: "会員番号には数値を入力してください",
            text: "入力値:" + this.memberNo,
          });
        } else {
          this.getProducts(this.memberNo, 1, () => {
            Message.success().fire({
              position: "center",
              showConfirmButton: true,
              timer: null,
              toast: false,
              title: "会員番号:" + this.memberNo + "に設定しました",
            });
          });
          this.isProxy = true;
          store.set("isProxy", "1");
        }
      }
    },
    clearMemberNo() {
      this.memberNo = "";
      store.set("isProxy", "0");
      this.getProducts(this.memberNo, "0");
      this.isProxy = false;
    },
    // 初回、ブラウザバック、代理注文会員指定とそのクリア時に呼ばれる
    getProducts(proxyMember, orderProxy, callback) {
      console.log("getProducts");
      let requestParams = request.createParams("webMdlCart", "getProducts", [
        proxyMember,
        orderProxy,
      ]);
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          console.log(data);
          const collectFunc = (category, products) => {
            const orders = productStore.getCategoryItems(category);
            if(this.shopping){
              this.shoppingItem = productStore.getCategoryItems("Shopping");
            }
            let items = [];
            orders.forEach((no) => {
              const targetItem = products.find((item) => item.no == no);
              if (targetItem && !this.shoppingItem.includes(no)) {
                items.push(products.find((item) => item.no == no));
              }
            });
            return items;
          };

          const categories = productStore.getCategories();
          this.products = [];
          // 商品カテゴリをループする
          categories.forEach((category) => {
            const items = collectFunc(category, data.products);
            if (items.length > 0) {
              this.products.push({
                category: category,
                items: collectFunc(category, data.products),
              });
            }
          });

          this.tools = collectFunc("TOOL", data.tools);
          this.isCanProxy = data.isCanProxy;
          this.memberNo = data.proxy;

          console.log(store.get("isProxy"));
          if (store.get("isProxy") == "") {
            store.set("isProxy", "0");
          }
          // this.$store.commit("refreshCart", orderProxy);
          this.cartRefresh();

          if (callback) callback();
        });
    },
  },
};
</script>
